module.exports = __webpack_public_path__ + "static/media/graph-analytics.dfd69cda.svg";